import apiService from '@/api/apiService';

export const addRole = async (name) => {
    const url = '/api/admin/roles';

    const data = {
        name: name
    };

    return apiService.POST(url, data);
};
